import { View } from "../../Core";
import Vue from "vue";
import { } from '@types/googlemaps';
import GoogleMap from "../../Components/GoogleMap/GoogleMap.vue";

class ViewDataModel {
    public shouldShowPayerInfo: Boolean;
}

export class ContactView extends View<ContactView> {
    private _viewData: ViewDataModel = window.__VIEW_DATA;

    public constructor() {
        super();
        this.SetupVue();
    }

    SetupVue() {
        let v = new Vue({
            el: ".app",
            data: {},
            components: {
                GoogleMap
            }
        });
    }
}


// WEBPACK FOOTER //
// ./www/js/Pages/Home/ContactView.ts